module.exports = __webpack_public_path__ + "static/box-9ff726b27872c88c1359e899f89a06d7.png";